import React from 'react';
import { useSelector } from 'react-redux';
import { FLOWS_ENUM } from '../../../common/enums';
import { selectTaxCertApplicationData } from '../../../store/slices/taxCertificate/taxCertificateSelectors';
import { ApplicationData } from 'src/types/flow';
import { RegistrantPage } from 'src/components/pages/RegistrantPage';
import { updateTaxCertApplicationData } from 'src/store/slices/taxCertificate/taxCertificateSlice';

const TaxCertRegistrant = () => {
  const data = (useSelector(selectTaxCertApplicationData) ??
    {}) as ApplicationData;
  return (
    <RegistrantPage
      allowRoleChange
      data={data}
      flow={FLOWS_ENUM.TAX_CERTIFICATE}
      updatePermitData={updateTaxCertApplicationData}
      title="Registrant"
    />
  );
};

export default TaxCertRegistrant;
